function stickyheaderLoadInit() {
  const headerElement = document.querySelector('.main-header-top');
  const header = headerElement && headerElement.querySelector('header[data-header-main]');
  const body = document.body;

  if (!headerElement || !header || !body) return;

  if (typeof window.cimoStickyHeaderCleanup === 'function') {
    window.cimoStickyHeaderCleanup();
  }

  const stickyHeader = header.getAttribute('data-sticky-header') === 'true';
  const stickyHeaderType = header.getAttribute('data-header-type');

  headerElement.classList.toggle('sticky-header-active', stickyHeader);
  body.classList.toggle('sticky-header-always', stickyHeader && stickyHeaderType === 'always');

  if (!stickyHeader) {
    headerElement.classList.remove('stickytrue', 'sticky-header-hidden');
    return;
  }

  const measureHeader = function () {
    const headerMain = headerElement.querySelector('[data-header-main]');
    if (!headerMain) return;

    const headerHeight = headerMain.getBoundingClientRect().height.toFixed(2);
    body.style.setProperty('--headerheight', `${headerHeight}px`);

    const announcementMain = document.querySelector('.announcement-wrapper');
    if (announcementMain) {
      const announcementHeight = announcementMain.getBoundingClientRect().height.toFixed(2);
      body.style.setProperty('--announcementheight', `${announcementHeight}px`);
    }

    if (window.innerWidth > 991 && headerElement.querySelector('[transparent="true"]')) {
      body.style.setProperty('--transparentheaderheight', `${headerHeight}px`);
    }
  };

  measureHeader();

  const COMPACT_ENTER_Y = 96;
  const COMPACT_EXIT_Y = 24;

  let lastY = Math.max(window.scrollY || 0, 0);
  let direction = null;
  let directionDistance = 0;
  let ticking = false;
  let resizeTimer = null;

  const interactionIsOpen = function () {
    return body.classList.contains('menuopen') ||
      body.classList.contains('mobile-menu-active') ||
      body.classList.contains('no-scroll') ||
      body.classList.contains('search-open') ||
      body.classList.contains('side-drawer-body-open') ||
      header.matches(':focus-within') ||
      header.querySelector('.site-nav-mega-menu:hover, .site-nav-dropdown:hover') !== null;
  };

  const updateStickyHeader = function () {
    const currentY = Math.max(window.scrollY || 0, 0);
    const delta = currentY - lastY;
    const wasCompact = headerElement.classList.contains('stickytrue');
    let isCompact = wasCompact;

    // Use separate enter/exit thresholds so the compact layout cannot oscillate
    // when its own height/layout change nudges the scroll position around a boundary.
    if (!wasCompact && currentY >= COMPACT_ENTER_Y) {
      isCompact = true;
    } else if (wasCompact && currentY <= COMPACT_EXIT_Y) {
      isCompact = false;
    }

    headerElement.classList.toggle('stickytrue', isCompact);

    if (wasCompact !== isCompact && window.innerWidth <= 991) {
      window.requestAnimationFrame(measureHeader);
    }

    if (stickyHeaderType === 'on_scroll') {
      if (currentY <= 140 || interactionIsOpen()) {
        headerElement.classList.remove('sticky-header-hidden');
        direction = null;
        directionDistance = 0;
      } else if (Math.abs(delta) >= 1) {
        const nextDirection = delta > 0 ? 'down' : 'up';

        if (nextDirection !== direction) {
          direction = nextDirection;
          directionDistance = 0;
        }

        directionDistance += Math.abs(delta);
        const threshold = nextDirection === 'down' ? 14 : 8;

        if (directionDistance >= threshold) {
          headerElement.classList.toggle('sticky-header-hidden', nextDirection === 'down');
          directionDistance = 0;
        }
      }
    } else {
      headerElement.classList.remove('sticky-header-hidden');
    }

    lastY = currentY;
    ticking = false;
  };

  const onScroll = function () {
    if (!ticking) {
      window.requestAnimationFrame(updateStickyHeader);
      ticking = true;
    }
  };

  const onResize = function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      measureHeader();
      updateStickyHeader();
    }, 120);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize);

  window.cimoStickyHeaderCleanup = function () {
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', onResize);
    window.clearTimeout(resizeTimer);
  };

  updateStickyHeader();
}

/* hamburger menu for mobile header */
function mobileHumburgerMenuInit() {
    let mobileHumburgerElements = document.querySelectorAll('[data-hamburger-mobile]');
    let headerMainParent = document.querySelector('header');
    let body = document.querySelector('body');

    Array.from(mobileHumburgerElements).forEach(function(element) {
        element.addEventListener("click", function(event) {
           event.preventDefault();
          let drawerElement =  element.getAttribute("href");
          let contentDrawerContainer= document.querySelector(drawerElement);
             if(element.classList.contains('active')){
                if (body.classList.contains('mobile-menu-active')) {
                    body.classList.remove('no-scroll', 'mobile-menu-active');
                    contentDrawerContainer.classList.remove('active');
                  element.classList.remove('active');
                }
             }else{
                    element.classList.add('active');
                    body.classList.add('no-scroll', 'mobile-menu-active');
                    contentDrawerContainer.classList.add('active');
              }
        });

    })
    window.addEventListener("resize", function() {
        if (window.innerWidth > 991 && body.classList.contains('mobile-menu-active')) {
            body.classList.remove('mobile-menu-active', 'no-scroll');
            document.querySelectorAll('.drawer-mobile-menu.active').forEach(function(drawer) {
              drawer.classList.remove('active');
            });
            mobileHumburgerElements.forEach(function(element) {
              element.classList.remove('active');
            });
        }
    })
}
function mobileMenuitemsEvent() {

  let mobileMenus = document.querySelectorAll(".mobile-menus-item");
    Array.from(mobileMenus).forEach(function(mobileMenu){
      mobileMenu.addEventListener("click",function(event){
        if(mobileMenu){
          mobileMenu.closest("[data-child-items]").classList.add("active")
        }

      })
    })
    let backToNavElemets = document.querySelectorAll("[data-backtonav-items],[data-subbacktonav-items]");
    Array.from(backToNavElemets).forEach(function(navBarbackElement) {
        navBarbackElement.addEventListener("click", function(event) {
          if(event.target.closest('details').hasAttribute("open")){
            event.target.closest('details[open]').removeAttribute("open");
            event.target.closest('[data-child-items].active').classList.remove("active");
          }
        })
    })

}

document.addEventListener('DOMContentLoaded', function () {
  stickyheaderLoadInit();
  mobileHumburgerMenuInit();
  mobileMenuitemsEvent();
});

document.addEventListener('shopify:section:load', function () {
  stickyheaderLoadInit();
  mobileHumburgerMenuInit();
  mobileMenuitemsEvent();
});
